import { BrowserModule, Title } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AreveaTVInterceptor } from "./core/interceptors/app.interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RecaptchaModule } from "ng-recaptcha";
import { ToastrModule, ToastrService } from "ngx-toastr";
import { SubscribeComponent } from "./pages/components/landing-pages/subscribe/subscribe.component";
import { ChannelsComponent } from "./pages/components/landing-pages/channels/channels.component";
// import { AmplifyAngularModule, AmplifyService, AmplifyModules } from 'aws-amplify-angular';
import { ConsumerVerificationCodeComponent } from "./pages/components/landing-pages/consumer/consumer-verification-code/consumer-verification-code.component";
import { TicketPurchasedConfirmDialog } from "./pages/components/landing-pages/consumer/consumer-verification-code/ticket-purchased-confirm.component";
import { ConsumerAcceptTeamsComponent } from "./pages/components/landing-pages/consumer/consumer-accept-teams/consumer-accept-teams.component";
import { ConsumerSignInComponent } from "./pages/components/landing-pages/consumer/consumer-sign-in/consumer-sign-in.component";
import { ConsumerForgotPasswordComponent } from "./pages/components/landing-pages/consumer/consumer-forgot-password/consumer-forgot-password.component";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AiAssistantComponent } from "./pages/layout/ai-assistant/ai-assistant.component";
// import Auth from '@aws-amplify/auth';
// import Interactions from '@aws-amplify/interactions';
// import Storage from '@aws-amplify/storage';
import {
  NgxUiLoaderModule,
  NgxUiLoaderHttpModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION,
} from "ngx-ui-loader";
import { FilterChannelDialogComponent } from "./pages/components/landing-pages/filter-channel-dialog/filter-channel-dialog.component";
import { SearchChannelsComponent } from "./pages/components/landing-pages/search-channels/search-channels.component";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { SignoutConfirmationDialogComponent } from "./pages/components/signout-confirmation-dialog/signout-confirmation-dialog.component";
import { CookieService } from "ngx-cookie-service";
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PageNotFoundComponent } from "./pages/components/landing-pages/consumer/page-not-found/page-not-found.component";
import { FanLandingPageComponent } from "./pages/components/landing-pages/fan-landing-page/fan-landing-page.component";
import { LandingPageSliderComponent } from "./pages/components/landing-pages/landing-page-slider/landing-page-slider.component";
import { CallBackComponent } from "./pages/components/call-back/call-back.component";
import { AuthorizeComponent } from "./pages/components/authorize/authorize.component";
import { PreRegisterComponent } from "./pages/components/landing-pages/pre-register/pre-register.component";
import { ConnectionService } from "ng-connection-service";
import { MobileCallbackComponent } from "./pages/components/mobile-callback/mobile-callback.component";
// import { BrowseAllComponent } from './pages/components/website/pages/browse-all/browse-all.component';
// import { CreatorsComponent } from './pages/components/website/pages/creators/creators.component';
// import { FansComponent } from './pages/components/website/pages/fans/fans.component';
// import { HomeComponent } from './pages/components/website/pages/home/home.component';
// import { WebsiteViewComponent } from './pages/components/website/layout/website-view/website-view.component';
import { OrganizersComponent } from "./pages/components/website/pages/organizers/organizers.component";
// import { PollComponent } from './pages/layout/poll/poll.component';
import { PopUpIconsComponent } from "./pages/components/website/pages/pop-up-icons/pop-up-icons.component";
import { CategoryComponent } from "./pages/components/website/pages/category/category.component";
import { PrivateChatComponent } from "./pages/layout/private-chat/private-chat.component";
import { ConfirmationDialogComponent } from "./pages/components/confirmation-dialog/confirmation-dialog.component";
import { NewLayoutComponent } from "./pages/components/website/layout/new-layout/new-layout.component";
import { RequestDemoComponent } from "./pages/components/landing-pages/consumer/request-demo/request-demo.component";
// import { ClaimTicketComponent } from './pages/components/landing-pages/consumer/claim-ticket/claim-ticket.component';
// import { ClaimTicketVerificationComponent } from './pages/components/landing-pages/consumer/claim-ticket-verification/claim-ticket-verification.component';
// import { CookiePloicyComponent } from './pages/components/landing-pages/cookie-ploicy/cookie-ploicy.component';
import { ForCreatorsComponent } from "./pages/components/website/pages/for-creators/for-creators.component";
import { ProductConfirmationDialogComponent } from "./pages/layout/product-confirmation-dialog/product-confirmation-dialog.component";
import { environment } from "src/environments/environment";
import { SampleThemePageComponent } from "./sample-theme-page/sample-theme-page.component";
import { WalletConnectDialogComponent } from "./pages/components/wallet-connect-dialog/wallet-connect-dialog.component";
import { IndigenousCloudModule } from "./pages/components/indigenous-cloud/indigenous-cloud.module";

import { MetamaskService } from "./core/services/wallet-connect.service";
import { CryptoInstructionsComponent } from "./pages/components/user-dashboard/crypto-instructions/crypto-instructions.component";
import { NftModule } from "./pages/components/nft/nft.module";
import { CommunitiesComponent } from './pages/components/communities/communities.component';
import { AiAgentComponent } from "./pages/layout/ai-agent/ai-agent.component";
import { AiAgentV2Component } from "./pages/layout/ai-agent-v2/ai-agent-v2.component";
import { FanNewsCardComponent } from "./pages/layout/ai-agent/fan-news-card/fan-news-card.component";
import { AgentTopBarComponent } from "./pages/layout/ai-agent/agent-top-bar/agent-top-bar.component";
import { AgentQuickActionsComponent } from "./pages/layout/ai-agent/agent-quick-actions/agent-quick-actions.component";
import { AgentRecommendedComponent } from "./pages/layout/ai-agent/agent-recommended/agent-recommended.component";
import { AgentGroupsBarComponent } from "./pages/layout/ai-agent/agent-groups-bar/agent-groups-bar.component";
import { AgentGroupsDialogComponent } from "./pages/layout/ai-agent/agent-groups-dialog/agent-groups-dialog.component";
import { AgentAskBarComponent } from "./pages/layout/ai-agent/agent-ask-bar/agent-ask-bar.component";
import { AgentPulseHeaderComponent } from "./pages/layout/ai-agent/agent-pulse-header/agent-pulse-header.component";
import { AgentPrefsCardComponent } from "./pages/layout/ai-agent/agent-prefs-card/agent-prefs-card.component";
import { AgentChatHistoryComponent } from "./pages/layout/ai-agent/agent-chat-history/agent-chat-history.component";
import { AgentChatHistoryDialogComponent } from "./pages/layout/ai-agent/agent-chat-history-dialog/agent-chat-history-dialog.component";
import { FanNewsStoryDialogComponent } from "./pages/layout/ai-agent/fan-news-story-dialog/fan-news-story-dialog.component";
import { FanNewsListDialogComponent } from "./pages/layout/ai-agent/fan-news-list-dialog/fan-news-list-dialog.component";
import { MarkdownModule } from 'ngx-markdown';
import { AuthCallbackComponent } from "./pages/components/landing-pages/consumer/onelogin-auth/google-auth-callback.component";
import { AppleAuthCallbackComponent } from "./pages/components/landing-pages/consumer/onelogin-auth/apple-auth-callback.component";
import { LogoTileDirective } from "./core/directives/logo-tile/logo-tile.directive";
// import { UpcomingEventsComponent } from './pages/components/website/pages/upcoming-events/upcoming-events.component';
// import { HomeUpdatesComponent } from './pages/components/website/pages/home-updates/home-updates.component';
// import { LiveEventsComponent } from './pages/layout/live-events/live-events.component';

let primaryColor = environment.themeColors["primaryColor"];
let secondaryFontColor = environment.themeColors["secondaryFontColor"];

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: primaryColor,
  bgsOpacity: 0.5,
  bgsPosition: POSITION.bottomRight,
  bgsSize: 90,
  bgsType: SPINNER.threeStrings,
  blur: 6,
  delay: 0,
  fgsColor: primaryColor,
  fgsPosition: "center-center",
  fgsSize: 110,
  fgsType: SPINNER.threeStrings,
  gap: 24,
  logoPosition: "center-center",
  logoSize: 120,
  logoUrl: "",
  masterLoaderId: "master",
  overlayBorderRadius: "0",
  overlayColor: "rgba(66,64,64,0.8)",
  pbColor: primaryColor,
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 3,
  hasProgressBar: true,
  text: "Loading...",
  textColor: secondaryFontColor,
};

@NgModule({
  declarations: [
    AppComponent,
    AppRoutingModule.COMPONENTS,
    SubscribeComponent,
    ChannelsComponent,
    ConsumerVerificationCodeComponent,
    TicketPurchasedConfirmDialog,
    // ClaimTicketVerificationComponent,
    ConsumerAcceptTeamsComponent,
    ConsumerSignInComponent,
    AuthCallbackComponent,
    AppleAuthCallbackComponent,
    ConsumerForgotPasswordComponent,
    FilterChannelDialogComponent,
    SearchChannelsComponent,
    SignoutConfirmationDialogComponent,
    PageNotFoundComponent,
    FanLandingPageComponent,
    LandingPageSliderComponent,
    CallBackComponent,
    AuthorizeComponent,
    PreRegisterComponent,
    MobileCallbackComponent,
    // BrowseAllComponent,
    // CreatorsComponent,
    // FansComponent,
    // HomeComponent,
    // WebsiteViewComponent,
    OrganizersComponent,
    PopUpIconsComponent,
    CategoryComponent,
    PrivateChatComponent,
    ConfirmationDialogComponent,
    NewLayoutComponent,
    RequestDemoComponent,
    // ClaimTicketVerificationComponent,
    // ClaimTicketComponent,
    // ClaimTicketVerificationComponent,
    // CookiePloicyComponent,
    ForCreatorsComponent,
    ProductConfirmationDialogComponent,
    SampleThemePageComponent,
    WalletConnectDialogComponent,
    AiAssistantComponent,
    CommunitiesComponent,
    AiAgentComponent,
    AiAgentV2Component,
    FanNewsCardComponent,
    FanNewsStoryDialogComponent,
    FanNewsListDialogComponent,
    AgentTopBarComponent,
    AgentQuickActionsComponent,
    AgentRecommendedComponent,
    AgentGroupsBarComponent,
    AgentGroupsDialogComponent,
    AgentAskBarComponent,
    AgentPulseHeaderComponent,
    AgentPrefsCardComponent,
    AgentChatHistoryComponent,
    AgentChatHistoryDialogComponent
    // UpcomingEventsComponent,
    // HomeUpdatesComponent
    // PollComponent,
    // LiveEventsComponent,
    // NewLayoutComponent,
    // RequestDemoComponent
  ],
  imports: [
    BrowserModule,
    LogoTileDirective,
    AppRoutingModule,
    IndigenousCloudModule,
    CoreModule.forRoot(),
    BrowserAnimationsModule,
    MatSliderModule,
    MatProgressBarModule,
    NftModule,
    RecaptchaModule,
    ToastrModule.forRoot({
      maxOpened: 1,
      autoDismiss: true,
      enableHtml: true,
      positionClass: "toast-center-center",
    }),
    HttpClientModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
      excludeRegexp: ["NOLOADER"],
    }),
    CarouselModule.forRoot(),
    DragDropModule,
    MarkdownModule.forRoot()
  ],
  exports: [NgxUiLoaderModule, NgxUiLoaderHttpModule],
  providers: [
    CookieService,
    Title,
    MetamaskService,
    { provide: HTTP_INTERCEPTORS, useClass: AreveaTVInterceptor, multi: true },
    // {
    //   provide: AmplifyService,
    //   useFactory: () => {
    //     return AmplifyModules({
    //       Auth,
    //       Storage,
    //       Interactions
    //     });
    //   }
    // }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {
  isConnected: any = true;
  connectionStatus = "ONLINE";
  constructor(
    private connectionService: ConnectionService,
    public toastr: ToastrService
  ) {
    this.connectionService.monitor().subscribe((isConnected) => {
      this.isConnected = isConnected;
      let beforeChangeStatus = this.connectionStatus;
      this.connectionStatus = this.isConnected ? "ONLINE" : "OFFLINE";
      if (this.connectionStatus == "OFFLINE") {
        this.toastr.error("No network connection");
      } else if (beforeChangeStatus == "OFFLINE" && this.connectionStatus) {
        this.toastr.success("Back online");
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    });
  }
}
